import React, { Component, Fragment } from 'react';
import i18n from "../../../../../../constants/initLng";
import Input from '../../../../common/component/Input';
import Switch from '../../../../common/component/Switch';
import * as HMS from '../../../../common/component/Index';
import * as Func from '../../../../../../helpers/functions';
import './style.less';
import { DETAIL_ACTIONS } from '../../../../../../constants/Define';
import AntSelect, { AntOption } from '../../../../common/component/AntSelect';
import Wrapper from '../../../../common/component/Wrapper';

export default class ExtendInfo extends Component {

    constructor(props) {
        super(props);
        this.state = {
            amenities: [],
            dataAmenity: []
        }
    }

    static getDerivedStateFromProps(props, state) {
        if (props.amenities !== state.amenities) {
            const newAmenities = props.amenities.filter(item => item.isActive)
            const newRoomTypeAmenity = props.roomType.amenity.filter(item => newAmenities.find(i => i.id === item))
            return {
                amenities: newAmenities,
                dataAmenity: newRoomTypeAmenity
            };
        }
        return null;
    }

    render() {
        const { loading, roomType, action, validation } = this.props;
        const { amenities, dataAmenity } = this.state;

        return (
            <div className="extend-info">
                <div className="extend-info-box">
                    <h3>{i18n.t(`item.roomType.extend_info`)}</h3>
                    <div className="row">
                        <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.roomType.refId`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input
                                    disabled={true}
                                    onChange={this.props.onChange}
                                    name={`refId`}
                                    value={roomType.refId}
                                    placeholder={i18n.t('item.roomType.refId')}
                                />

                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group col-md-6">
                        {
                            action !== DETAIL_ACTIONS.CREATE &&
                                <HMS.FormWrapperInputComponent
                                    isRequired={false}
                                    isValidation={false}
                                    labelTitle={i18n.t(`item.roomType.isActive`)}
                                    visible={action !== DETAIL_ACTIONS.TRANSLATE}
                                >
                                    <br />
                                    <Switch defaultChecked={roomType.isActive} onChange={(value) => this.props.onChange({ value: value, name: 'isActive' })} name={`isActve`} disabled={loading} />
                                </HMS.FormWrapperInputComponent>
                        }
                        </div>
                        <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.roomType.area`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input
                                    onChange={this.props.onChange}
                                    name={`area`}
                                    value={Func.formatMoney(Func.checkUndefine(roomType.area))}
                                    placeholder={i18n.t('item.roomType.area')} />

                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={true}
                                isValidation={true}
                                dataValidation={roomType.numberOfRoom}
                                validation={validation.numberOfRoom}
                                labelTitle={i18n.t(`item.roomType.numberOfRoom`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input
                                    onChange={this.props.onChange}
                                    name={`numberOfRoom`}
                                    value={Func.formatRoomType(Func.checkUndefine(roomType.numberOfRoom))}
                                    disabled={loading}
                                    placeholder={i18n.t('item.roomType.numberOfRoom')}
                                />
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.roomType.bedType`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input
                                    onChange={this.props.onChange}
                                    name={`bedType`}
                                    value={Func.checkUndefine(roomType.bedType)}
                                    placeholder={i18n.t('item.roomType.bedType')} />

                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.roomType.maxAdult`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input onChange={this.props.onChange} name={`maxAdult`} value={Func.formatMoney(Func.checkUndefine(roomType.maxAdult))} disabled={loading} placeholder={i18n.t('item.roomType.maxAdult')}/>
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.roomType.maxChildren`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input onChange={this.props.onChange} name={`maxChild`} value={Func.formatMoney(Func.checkUndefine(roomType.maxChild))} disabled={loading} placeholder={i18n.t('item.roomType.maxChildren')}/>
                            </HMS.FormWrapperInputComponent>
                        </div> 
                        <Wrapper className="form-group col-md-12">
                            <HMS.FormWrapperInputComponent
                                labelTitle={i18n.t(`item.roomType.amenity`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <AntSelect className="select-types"
                                    showArrow
                                    mode="multiple"
                                    placeholder={Func.capitalizeFirstLetter((i18n.t('placeHolderForm.select') + " " + i18n.t("item.hotel.amenity")).toLowerCase())}
                                    value={dataAmenity}
                                    onChange={amenity => this.props.onChangeAmenity('amenity', amenity)}
                                    style={{ width: '100%' }}
                                    optionFilterProp="children"
                                >
                                    {(amenities || []).map(amenity => (
                                        amenity.isActive && <AntOption key={amenity.id} value={amenity.id}>
                                            {amenity.name}
                                        </AntOption>
                                    ))}
                                </AntSelect>
                            </HMS.FormWrapperInputComponent>
                        </Wrapper>
                        {/* <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.roomType.square_unit`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input onChange={this.props.onChangeRoomFeatures} name={`square_unit`} value={Func.formatMoney(Func.checkUndefine(roomType.features.square_unit))} disabled={loading} placeholder={i18n.t('item.roomType.square_unit')}/>
                            </HMS.FormWrapperInputComponent>
                        </div>
                        <div className="form-group col-md-6">
                            <HMS.FormWrapperInputComponent
                                isRequired={false}
                                isValidation={false}
                                labelTitle={i18n.t(`item.roomType.square_unit_type`)}
                                visible={action !== DETAIL_ACTIONS.TRANSLATE}
                            >
                                <Input onChange={this.props.onChangeRoomFeatures} name={`square_unit_type`} value={roomType.features.square_unit_type} disabled={loading} placeholder={i18n.t('item.roomType.square_unit_type')}/>
                            </HMS.FormWrapperInputComponent>
                        </div> */}
                    </div>
                </div>
            </div>
        );
    }
}

